"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccessCheck = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const licenses_1 = require("@completeanatomy/licenses");
const user_1 = require("@completeanatomy/user");
function useAccessCheck(modifier = bridge_schema_1.UIAccessModifier.Regular, defaultLevel = bridge_schema_1.AccessLevel.Upgraded) {
    const licenses = (0, licenses_1.useUserLicenses)();
    const user = (0, user_1.useUser)();
    const hasLicenses = licenses !== undefined &&
        licenses.filter(license => license.isActive).length > 0;
    const isLoggedInUser = user !== null && user !== undefined;
    const regularAccess = modifier === bridge_schema_1.UIAccessModifier.Regular;
    const licenseAvailable = hasLicenses &&
        !regularAccess &&
        isLoggedInUser &&
        defaultLevel < bridge_schema_1.AccessLevel.Subscribed;
    const hasSubscribedLicense = hasLicenses &&
        licenses.some(license => license.type !== bridge_schema_1.LicenseType.Individual &&
            license.type !== bridge_schema_1.LicenseType.School);
    const subscribedLicense = !regularAccess &&
        isLoggedInUser &&
        defaultLevel === bridge_schema_1.AccessLevel.Subscribed &&
        hasSubscribedLicense;
    return regularAccess || licenseAvailable || subscribedLicense;
}
exports.useAccessCheck = useAccessCheck;
